export default __webpack_public_path__ + "static/media/EM0940.34I-27374_-16506_0.34499afb.jpg";